export default "__VITE_ASSET__D7Z4gSXQ__"